import API from "@utils/plugins/API";

const EquipmentTypeService = {
  all: (params) => {
    return API.get("equipments", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("equipments", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`equipments/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`equipments/${id}`);
  },
  destroy: (id) => {
    return API.delete(`equipments/${id}`);
  },
};

export default EquipmentTypeService;
